module.exports = __webpack_public_path__ + "static/media/tb-picture-1.9e26a19a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TeamBuilding/tb-picture-1.png
// module id = 612
// module chunks = 0